import { DOCUMENT, booleanAttribute, ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NavigationConfigService } from '../config.service';
import { Router } from '@angular/router';
import { injectQueryParams } from 'ngxtension/inject-query-params';

@Component({
  selector: 'nav-not-enabled',
  templateUrl: './not-enabled.component.html',
  styleUrls: ['./not-enabled.component.scss'],
  imports: [TranslocoPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotEnabledComponent implements OnInit {
  doc = inject(DOCUMENT);
  configService = inject(NavigationConfigService);
  private router = inject(Router);

  cueSolutionValidLicence = injectQueryParams('cueSolutionValidLicence', {
    parse: booleanAttribute,
  });
  enabled = injectQueryParams('enabled', {
    parse: booleanAttribute,
  });

  ngOnInit(): void {
    const el = this.doc.getElementById('appLoading');
    if (el) {
      el.parentElement.removeChild(el);
    }

    if (this.configService.value.enabled && this.configService.value.cueSolutionValidLicence) {
      this.router.navigate(['']);
    }
  }
}
